import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-137">
      {/* Red urgency countdown strip */}
      <div className="bg-red-900/60 py-4 px-4 text-center border-y border-red-800/50" data-id="element-138">
        <p className="text-red-300 font-black text-sm md:text-base tracking-widest mb-2 animate-pulse uppercase" data-id="element-139">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <CountdownTimer className="!text-red-300 [&_div]:!border-red-700/50 [&_div]:!bg-red-950/80 [&_span]:!text-red-400/60 !text-2xl md:!text-4xl mb-1" data-id="element-140" />
        <p className="text-red-400/80 font-black text-[10px] md:text-xs uppercase tracking-widest mt-2" data-id="element-141">
          Después sube el precio y no vuelve a bajar.
        </p>
        <div className="max-w-md mx-auto mt-3" data-id="element-142">
          <div className="flex justify-between text-[10px] md:text-xs font-black mb-1 uppercase" data-id="element-143">
            <span className="flex items-center text-red-300" data-id="element-144">
              <span className="w-2 h-2 rounded-full bg-red-400 mr-1.5 animate-ping" data-id="element-145"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-red-400/80" data-id="element-146">Quedan pocos</span>
          </div>
          <div className="w-full bg-red-950 rounded-full h-2 overflow-hidden border border-red-800/30" data-id="element-147">
            <div className="bg-red-400 h-2 rounded-full w-[78%]" data-id="element-148"></div>
          </div>
          <p className="text-[9px] md:text-[10px] text-red-400/70 font-bold mt-1 text-right uppercase" data-id="element-149">
            78% de los cupos tomados
          </p>
        </div>
      </div>

      {/* Pricing section - Single Offer */}
      <div className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-150">
        <div className="max-w-2xl mx-auto" data-id="element-151">
          <div className="text-center mb-5" data-id="element-152">
            <h2 className="text-xl md:text-3xl font-black text-white tracking-tight leading-none uppercase" data-id="element-153">
              Elegí tu Kit:
            </h2>
          </div>

          {/* Single Premium Kit */}
          <div className="bg-brand-card rounded-xl border-4 border-brand-accent p-5 md:p-8 flex flex-col relative shadow-[0_0_40px_rgba(0,255,136,0.2)] transform hover:scale-[1.02] transition-transform duration-300" data-id="element-154">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-black px-6 py-1.5 rounded-full text-xs md:text-sm tracking-widest shadow-lg whitespace-nowrap uppercase" data-id="element-155">
              🏆 OFERTA ÚNICA
            </div>

            <h3 className="text-lg md:text-2xl font-black text-white mb-2 mt-2 leading-tight text-center uppercase" data-id="element-156">
              KIT COMPLETO FILOSOFÍA LISTA
            </h3>

            <p className="text-brand-accent font-bold text-sm md:text-base mb-4 text-center" data-id="element-157">
              Los 6 tomos + 4 bonos estratégicos + Actualizaciones de por vida
            </p>

            <div className="flex flex-col items-center justify-center mb-6 bg-brand-dark/50 py-4 rounded-lg border border-white/5" data-id="element-158">
              <span className="text-sm text-gray-500 line-through font-black mb-1" data-id="element-159">
                USD 45.00
              </span>
              <div className="flex items-baseline gap-2" data-id="element-160">
                <span className="text-sm font-bold text-gray-300" data-id="element-161">Hoy:</span>
                <span className="text-4xl md:text-5xl font-black text-brand-accent neon-glow" data-id="element-162">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href="https://kit-online-2026.myshopify.com/cart/44541109960839:1" className="py-4 md:py-5 text-base md:text-xl shadow-[0_0_30px_rgba(0,255,136,0.5)] w-full" pulse={true} data-id="element-163">
              📜 → QUIERO EL KIT COMPLETO
            </Button>
          </div>

          <p className="text-[9px] md:text-[10px] text-gray-500 text-center mt-6 mb-5 font-bold leading-relaxed max-w-xl mx-auto" data-id="element-164">
            El precio está en dólares estadounidenses (USD). El cobro se realiza
            automáticamente en la moneda de tu país al tipo de cambio del
            momento. Pagás en pesos argentinos, pesos mexicanos, pesos
            colombianos, soles peruanos, pesos chilenos, guaraníes, bolívares,
            quetzales, lempiras, colones, balboas, córdobas o cualquier otra
            moneda local según tu país de origen.
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-300 font-black uppercase tracking-wide" data-id="element-165">
            <div className="flex items-center" data-id="element-166">
              <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-167" />
              <span data-id="element-168">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-169">
              <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-170" />
              <span data-id="element-171">Acceso en 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-172">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-173" />
              <span data-id="element-174">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}